import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class LabelsAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // GET_ALL //
  getAllError() {
    const message = {
      body: 'LABEL_GET_ALL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'LABEL_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'LABEL_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateOneSuccess(label) {
    const message = {
      body: 'X_LABEL_UPDATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: label.name})
  }

  updateOneError() {
    const message = {
      body: 'LABEL_UPDATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.labels')
  .service('labelsAlertsService', LabelsAlertsService);
